<template>
  <div>
    <a-form-model
      ref="ruleForm"
      :labelCol="labelCol"
      :wrapperCol="wrapperCol"
      :rules="formRules"
      :model="formData"
      class="form"
    >
      <a-row :gutter="24">
        <a-col :sm="24" :md="12" :xl="12">
          <a-form-model-item label="出租方式" prop="rentType">
            <a-radio-group v-model="formData.rentType">
              <a-radio
                :value="item.dictCode"
                :key="item.dictCode"
                v-for="item in baseInfo.rentTypeList"
                >{{ item.dictName }}</a-radio
              >
            </a-radio-group>
          </a-form-model-item>
        </a-col>

        <a-col :sm="24" :md="12" :xl="12">
          <a-form-model-item label="小区" prop="communityName">
            <a-input
              allowClear
              v-model="formData.communityName"
              @click="onSearch"
              placeholder="选择小区"
            />
          </a-form-model-item>
        </a-col>

        <a-col :sm="24" :md="12" :xl="12">
          <a-form-model-item label="户型" prop="roomLayout">
            <a-select
              allowClear
              showSearch
              v-model="formData.roomLayout"
              placeholder="请选择户型"
            >
              <a-select-option
                v-for="item in baseInfo.roomLayoutList"
                :key="item.dictCode"
                :value="item.dictCode"
                >{{ item.dictName }}</a-select-option
              >
            </a-select>
          </a-form-model-item>
        </a-col>

        <a-col :sm="24" :md="12" :xl="12">
          <a-form-model-item label="楼号" prop="buildingNo"
            ><a-input placeholder="请输入楼号" v-model="formData.buildingNo"
          /></a-form-model-item>
        </a-col>

        <a-col :sm="24" :md="12" :xl="12">
          <a-form-model-item label="单元号" prop="unitNo"
            ><a-input placeholder="请输入单元号" v-model="formData.unitNo"
          /></a-form-model-item>
        </a-col>

        <a-col :sm="24" :md="12" :xl="12">
          <a-form-model-item label="门牌号" prop="houseNum"
            ><a-input placeholder="请输入门牌号" v-model="formData.houseNum"
          /></a-form-model-item>
        </a-col>

        <a-col :sm="24" :md="12" :xl="12">
          <a-form-model-item label="当前楼层" prop="floor">
            <a-select
              showSearch
              v-model="formData.floor"
              placeholder="请选择当前楼层"
            >
              <a-select-option
                v-for="item in baseInfo.floorList"
                :key="item"
                :value="item"
                >{{ item }}</a-select-option
              >
            </a-select>
          </a-form-model-item>
        </a-col>

        <a-col :sm="24" :md="12" :xl="12">
          <a-form-model-item label="总楼层" prop="totalFloor">
            <a-select
              showSearch
              v-model="formData.totalFloor"
              placeholder="请选择总楼层"
            >
              <a-select-option
                v-for="item in baseInfo.totalFloorList"
                :key="item"
                :value="item"
                >{{ item }}</a-select-option
              >
            </a-select>
          </a-form-model-item>
        </a-col>

        <a-col :sm="24" :md="12" :xl="12">
          <a-form-model-item label="管家" prop="keeperNo">
            <a-select
              showSearch
              v-model="formData.keeperNo"
              placeholder="请选择管家"
            >
              <a-select-option
                v-for="item in baseInfo.keeperList"
                :key="item.userNo"
                :value="item.userNo"
                >{{ item.nickName }}-{{ item.mobile }}</a-select-option
              >
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="24" :md="12" :xl="12">
          <a-form-model-item label="采暖方式" prop="heatingType">
            <a-select
              showSearch
              v-model="formData.heatingType"
              placeholder="请选择采暖方式"
            >
              <a-select-option
                v-for="item in baseInfo.heatingTypeList"
                :key="item.dictCode"
                :value="item.dictCode"
                >{{ item.dictName }}</a-select-option
              >
            </a-select>
          </a-form-model-item>
        </a-col>

        <a-col :sm="24" :md="24" :xl="24">
          <a-form-model-item label="描述" prop="roomIntro">
            <a-input
              style="width: 100%;"
              v-model="formData.roomIntro"
              :rows="4"
              type="textarea"
              placeholder="请输入房源描述"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <div class="operation">
      <a-button type="primary" @click="nextStep">下一步</a-button>
      <a-button style="margin-left: 8px" @click="back">返回房源列表</a-button>
    </div>
    <a-divider />
    <div class="step-form-style-desc">
      <h3>说明</h3>
      <h4>合租</h4>
      <p>这里填写房源的相同的信息</p>
    </div>
    <!-- 小区选择 -->
    <community-modal ref="comModal" @sure="selectCommunity"></community-modal>
  </div>
</template>

<script>
import CommunityModal from "./CommunityModal";
export default {
  components: {
    CommunityModal
  },
  name: "Step1",
  props: {
    baseInfo: {
      type: Object,
      default: function() {
        return {};
      }
    },
    queryParam: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      formData: {
        rentType: "", //出租方式
        communityCode: "", //小区
        communityName: "", //小区名
        roomLayout: undefined, //户型
        buildingNo: "", //楼号
        unitNo: "", //单元号
        houseNum: "", //门牌号
        floor: "1", //当前楼层
        totalFloor: "99", //总楼层
        heatingType: undefined, //采暖方式
        keeperNo: undefined, //管家
        merchantNo: "", //商户id
        roomIntro: undefined //房源描述
      },
      formRules: {
        rentType: [{ required: true, message: "请选择出租方式" }],
        communityName: [{ required: true, message: "请选择小区" }],
        roomLayout: [{ required: true, message: "请选择户型" }],
        floor: [{ required: true, message: "请选择当前楼层" }],
        totalFloor: [{ required: true, message: "请选择总楼层" }],
        buildingNo: [{ required: true, message: "请输入楼号" }],
        keeperNo: [{ required: true, message: "请选择管家" }],
        heatingType: [{ required: true, message: "请选择采暖方式" }],
        unitNo: [{ required: true, message: "请输入单元号" }],
        roomIntro: [{ required: true, message: "请输入房源描述" }],
        houseNum: [{ required: true, message: "请输入门牌号" }]
      }
    };
  },
  methods: {
    fillFormData(obj) {
      console.log(obj);
    },
    onSearch() {
      this.$refs.comModal.show();
    },
    selectCommunity(item) {
      this.formData.communityName = item.communityName;
      this.formData.communityCode = item.communityCode;
    },
    back() {
      this.$router.push({
        name: "HouseList",
        query: { param: this.queryParam }
      });
    },

    nextStep() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let data = this.formData;
          this.$emit("nextStep", 1, data);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.form {
  max-width: 700px;
  margin: 40px auto 0;
}
/deep/ .ant-form-item-label {
  width: 80px !important;
}
.operation {
  text-align: center;
  margin: 5px auto;
}
.step-form-style-desc {
  padding: 0 56px;
  color: rgba(0, 0, 0, 0.45);

  h3 {
    margin: 0 0 12px;
    color: rgba(0, 0, 0, 0.45);
    font-size: 16px;
    line-height: 32px;
  }

  h4 {
    margin: 0 0 4px;
    color: rgba(0, 0, 0, 0.45);
    font-size: 14px;
    line-height: 22px;
  }

  p {
    margin-top: 0;
    margin-bottom: 12px;
    line-height: 22px;
  }
}
</style>
